import { Inject, Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { AppInjector } from "@app/core/functions/app-injector";

/**
 * Transforms all ussi responses
 */
@Injectable({
  providedIn: "root"
})
export class NodeJSAuthenticationInterceptor implements HttpInterceptor {
  constructor(@Inject(undefined) public refresh: boolean) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modifiedRequest: HttpRequest<any> = this.addTokenHeader(request);
    return next.handle(modifiedRequest);
  }

  /**
   * Add token header to request
   * @param request
   * @returns
   */
  addTokenHeader(request: HttpRequest<any>) {
    const modifiedRequest: HttpRequest<any> = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.authService.credentials.nodeJsAuthentication.accessToken}`,
        ...(this.refresh ? { Refresh: `Bearer ${this.authService.credentials.nodeJsAuthentication.refreshToken}` } : {})
      }
    });
    return modifiedRequest;
  }

  /**
   * Inject authentication service at runtime
   */
  private get authService(): AuthenticationService {
    return AppInjector.get(AuthenticationService);
  }
}
